import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton } from "@/pages/AuthShell";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { formatApiError } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!agree) { setError("Anda harus menyetujui Syarat & Ketentuan dan Kebijakan Privasi."); return; }
    setLoading(true);
    try {
      await register({ ...form, terms_accepted: true, privacy_accepted: true });
      navigate("/onboarding");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Buat akun gratis" subtitle="Dapatkan 3 analisis gratis untuk mulai."
      footer={<>Sudah punya akun? <Link to="/login" className="text-teal font-semibold" data-testid="to-login">Masuk</Link></>}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        {error && <div data-testid="register-error" className="bg-red-50 text-red-700 text-sm rounded-xl p-3">{error}</div>}
        <div>
          <Label htmlFor="name">Nama</Label>
          <Input id="name" data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl h-12 mt-1" placeholder="Nama Anda" />
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input id="email" data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-xl h-12 mt-1" placeholder="nama@email.com" />
        </div>
        <div>
          <Label htmlFor="password">Kata Sandi</Label>
          <Input id="password" data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-xl h-12 mt-1" placeholder="Minimal 6 karakter" />
        </div>
        <label className="flex items-start gap-2 text-sm text-muted-foreground cursor-pointer">
          <Checkbox data-testid="register-agree" checked={agree} onCheckedChange={setAgree} className="mt-0.5" />
          <span>Saya menyetujui <Link to="/syarat" className="text-teal">Syarat & Ketentuan</Link> dan <Link to="/privasi" className="text-teal">Kebijakan Privasi</Link>.</span>
        </label>
        <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full h-12 rounded-full bg-teal hover:bg-teal-hover text-base font-semibold">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Daftar Gratis"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-5"><div className="h-px bg-border flex-1" /><span className="text-xs text-muted-foreground">atau</span><div className="h-px bg-border flex-1" /></div>
      <GoogleButton label="Daftar dengan Google" />
    </AuthShell>
  );
}
